export class TableColumn<T = unknown> {
  constructor(
    public key: string,
    public label: string,
    public sortable: boolean,
    public tooltip?: (row: T) => string,
    public align: 'left' | 'center' | 'right' = 'center',
    public formatFn?: (value: string | number | Date, row?: T) => string,
  ) {}
}
